import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { FetchUserAccount } from '../../../actions/UserAccount';
import { userRoles } from '../../../constants/UserRoles';
import CustomerDashboard from '../../CSAgent/CustomerDashboard/CustomerDashboard';
import ErrorPage from '../../../components/shared/errorPage/ErrorPage';
import Loader from '../../../components/shared/loader/Loader';

/**
 * source
 * role
 * agentid
 * serialnumber
 * country
 * x-api-key
 * @returns 
 */
const C4CDashboard = () => {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const BPID = query.get('bpid');
  const serialNumber = query.get('serialNumber');
  const isRequiredAttributesMissing = !serialNumber && !BPID;
  const userAccount = useSelector(state => state.UserAccount);
  const roles = userAccount?.userAccount?.roles;

  // eslint-disable-next-line
  const [searchTerms, setSearchTerms] = useState(() => {
    if( serialNumber && BPID ){
      return { "serial_number": serialNumber, "BusinessPartnerId": BPID };
    }
    else if (serialNumber) {
      return { "serial_number": serialNumber };
    } else if (BPID) {
      return { "BusinessPartnerId": BPID };
    }
    return {};
  });

  useEffect(() => {
    if(!isRequiredAttributesMissing){
      dispatch(FetchUserAccount(null, null, null, null));
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  if (userAccount?.loading) {
    return <Loader />
  }
  if (userAccount?.error) {
     return <ErrorPage errorInfo= {userAccount?.error}/>
  }
  if(userAccount?.success && !roles?.includes(userRoles.CSAGENT_VIEWER)){
    return <ErrorPage errorInfo= "UnAuthorized Access"/>
  }

  if(isRequiredAttributesMissing){
    return <ErrorPage errorInfo="Error Occured. Required attributes missing"/>
  }
  const isDashboardReady = userAccount?.success && Object.keys(searchTerms).length > 0;

  return (
    <div className='c4c-wrapper'>
      { (isDashboardReady)
        ? <CustomerDashboard searchTerms={searchTerms}  />
        : <Loader />
      }
    </div>
  );
};

export default C4CDashboard;
